import { el, progress } from '../dom.js';
import { copy } from '../copy.js';

export function renderDone(state) {
  const lines = [];
  if (state.photos.modem?.recognized) {
    lines.push(summaryLine('Modem', state.photos.modem));
  }
  if (state.photos.gateway?.recognized) {
    lines.push(summaryLine('Main router', state.photos.gateway));
  }
  for (const ap of state.photos.aps) {
    lines.push(summaryLine(ap.room || 'Access point', ap));
  }

  const screen = el('div', { class: 'screen' });
  screen.appendChild(progress({ step: 4, total: 4 }));
  screen.appendChild(el('h1', { text: copy.done.title }));
  screen.appendChild(el('p', { text: copy.done.body }));

  if (lines.length > 0) {
    screen.appendChild(el('p', { text: copy.done.summaryLabel }));
    const chips = el('div', { class: 'captured' });
    for (const line of lines) chips.appendChild(line);
    screen.appendChild(chips);
  }

  return screen;
}

function summaryLine(label, photo) {
  const vendorModel = [photo.extraction?.vendor, photo.extraction?.model]
    .filter(Boolean)
    .join(' ');
  const text = vendorModel ? `${label}: ${vendorModel}` : label;
  return el('span', { class: 'chip' }, [el('span', { class: 'check', text: '✓' }), ` ${text}`]);
}
